import { Fragment, type ReactNode } from "react";
import TextWithRegisteredMark from "~/componentsDS/TextWithRegisteredMark";
import AuthorInfo from "./AuthorInfo";
import { type InfoTestimonialV3 } from "./data";
import { cn } from "~/lib/utils";

const renderTestimonialLine = (line: ReactNode) =>
    typeof line === "string" ? <TextWithRegisteredMark text={line} /> : line;

const renderTestimonialText = (text: InfoTestimonialV3["text"]) => {
    if (!Array.isArray(text)) {
        return renderTestimonialLine(text);
    }

    return text.map((line, index) => (
        <Fragment key={index}>
            {renderTestimonialLine(line)}
            {index < text.length - 1 && (
                <>
                    <br />
                    <br />
                </>
            )}
        </Fragment>
    ));
};

const InfoSlide = ({ testimonial, className }: { testimonial: InfoTestimonialV3; className?: string }) => {
    const { text, author, photo, photoAlt } = testimonial;

    return (
        <div
            className={cn(
                "flex h-[514px] flex-col overflow-hidden rounded-3xl bg-[#E9EDF7] px-6 py-6 md:px-8",
                className
            )}
        >
            <p className="relative mb-auto flex-col whitespace-break-spaces font-suisseBP text-[22px] font-normal leading-[1.4] tracking-[-0.01em] text-primary500 md:text-[32px] md:font-light md:leading-[1.1]">
                <span className="absolute -translate-x-full">&ldquo;</span>
                {renderTestimonialText(text)}
                <span>&rdquo;</span>
            </p>

            <AuthorInfo photo={photo} author={author} photoAlt={photoAlt} />
        </div>
    );
};

export default InfoSlide;
